import React, { useState, useEffect, useRef } from "react";
import { useFormCtx } from "../FormContext";

const MouseCursor = () => {
  const { isCursorEnabled, loaded } = useFormCtx();

  const [isVisible, setIsVisible] = useState(false);
  const timerRef = useRef(null);
  const [mousePos, setMousePos] = useState({ x: 0, y: 0 });

  const debugShow = false;

  useEffect(() => {
    const events = ["mousemove", "mousedown"];
    //console.log("xxxx", isCursorEnabled, debugShow);

    const resetTimer = (withNewStart = false) => {
      //Vymažeme předchozí odpočet
      if (timerRef.current) {
        clearTimeout(timerRef.current);
        //console.log("xxxx resetTimer clearTimeout");
      }

      if (withNewStart) {
        //Nastavíme nový odpočet na 3000ms (3 sekundy)
        timerRef.current = setTimeout(() => setIsVisible(false), 3000);
        //console.log("xxxx resetTimer start new");
      }
    };

    // Jedna funkce pro všechny události
    const handleInteraction = (event) => {
      if (isCursorEnabled || debugShow) {
        // 1. Jakmile pohneme myší, ukážeme kurzor
        setIsVisible(true);
        // clientX/Y sleduje pozici v rámci okna prohlížeče
        setMousePos({ x: event.clientX, y: event.clientY });
        resetTimer(true); // Tvoje logika pro schování kurzoru
      }
    };

    if (isCursorEnabled || debugShow) {
      // Hromadné přidání eventu
      events.forEach((event) => window.addEventListener(event, handleInteraction));
    }

    return () => {
      if (isCursorEnabled || debugShow) {
        // Hromadné uklid eventu z pameti
        events.forEach((event) => window.removeEventListener(event, handleInteraction));
        resetTimer();
      }
    };
  }, [loaded, isCursorEnabled]);

  if (!isCursorEnabled && !debugShow) {
    return;
  }

  return (
    <>
      {/* Informační box v rohu */}
      {/* <div className="fixed bottom-4 right-4 z-[9999] bg-black text-white p-4 rounded font-mono text-xl  border border-white shadow-2xl pointer-events-none">
        X: {mousePos.x} | Y: {mousePos.y}
      </div> */}
      {isVisible && (
        <div
          className="fixed cursor-pointer top-0 left-0 w-6 h-6 z-[9999] pointer-events-none -translate-x-1/2 -translate-y-1/2"
          style={{
            transform: `translate(${mousePos.x}px, ${mousePos.y}px)`,
            transition: "transform 0.00s linear", // jemné vyhlazení
          }}
        >
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960" className="size-10 tvHD:size-12 tv4K:size-24 stroke-black stroke-[30px] fill-white">
            <path d="M572.33-16 412-358 208.67-72.33v-875.34l676.66 532h-349l159 342.34-123 57.33Z" />
          </svg>
        </div>
      )}
    </>
  );
};

export default MouseCursor;
